export const DefaultLanguage = 'defaultLang';

export const IS_WHATSAPP_CASCADE_ENABLED = false;
